import {doAjax} from "surveylabJsAssets/common/_ajax";

export default function () {
    $(function () {
        let timeoutID;
        const $waveAdmingMsg = $('.wave-admin-msg');
        $('.form-check.form-switch').on('click', (e) => {
            doAjax({
                url: $('#wave-admin-urls').data('toggle-is-wave-data-shown'),
            }).done((response) => {
                if (timeoutID) {
                    $waveAdmingMsg.hide();
                    window.clearTimeout(timeoutID);
                }
                $waveAdmingMsg.html(response.msg).addClass('alert-success').show();
                timeoutID = window.setTimeout(() => {
                    $waveAdmingMsg.hide().removeClass('alert-success');
                }, 4000);
            });
        });
    });
}